import React from 'react';
import { Wrench, Target, CheckCircle, Briefcase, ListTodo, Kanban } from 'lucide-react';
import WorkspaceHeader from './WorkspaceHeader';
import ProjectList from '../workshop/ProjectList';
import TaskBoard from '../workshop/TaskBoard';
import KanbanBoard from '../workshop/KanbanBoard';
import WorkshopOverview from '../workshop/WorkshopOverview';
import TaskManager from '../workshop/TaskManager';

interface WorkshopWorkspaceProps {
  activeArea: string;
}

export default function WorkshopWorkspace({ activeArea }: WorkshopWorkspaceProps) {
  const renderContent = () => {
    switch (activeArea) {
      case 'projects':
        return (
          <>
            <WorkspaceHeader
              title="Projects"
              icon={Briefcase}
              description="Manage and track all your projects"
            />
            <ProjectList />
          </>
        );
      case 'tasks':
        return (
          <>
            <WorkspaceHeader
              title="Tasks"
              icon={ListTodo}
              description="Track and manage project tasks"
            />
            <TaskBoard />
          </>
        );
      case 'kanban':
        return (
          <>
            <WorkspaceHeader
              title="Kanban Board"
              icon={Kanban}
              description="Visualize work progress"
            />
            <KanbanBoard />
          </>
        );
      case 'task-manager':
        return (
          <>
            <WorkspaceHeader
              title="Task Manager"
              icon={CheckCircle}
              description="View and manage tasks from all departments"
            />
            <TaskManager />
          </>
        );
      case 'overview':
      default:
        return (
          <>
            <WorkspaceHeader
              title="Workshop Overview"
              icon={Wrench}
              description="Your production and project management hub"
            />
            <WorkshopOverview />
          </>
        );
    }
  };

  return renderContent();
}